// extracted by mini-css-extract-plugin
export var form = "_41-0";